import { LinearProgress, Typography } from 'beam'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { TenantSummary } from '../LegacyLogin/login.api'
import { Row } from './Row'
import { SubmissionValueDisplay } from './SubmissionValueDisplay'

export interface LoggingInProps {
  email: string,
  tenant?: TenantSummary,
}

export function LoggingIn({ email, tenant }: LoggingInProps): ReactElement {
  const { t } = useTranslation()
  return <>
    <Row>
      <SubmissionValueDisplay name={t('email')}>{email}</SubmissionValueDisplay>
    </Row>
    {tenant && <Row>
      <SubmissionValueDisplay name={t('tenant')}>{tenant.name}</SubmissionValueDisplay>
    </Row>}
    <Row>
      <Typography>{t('loggingIn')}</Typography>
    </Row>
    <Row><LinearProgress /></Row>
  </>
}
